"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronRightIcon = function ChevronRightIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || '0 0 32 32',
    fill: fill,
    className: className,
    path: "M20.6893 16L13.7197 22.7585C13.4268 23.0425 13.4268 23.503 13.7197 23.787C14.0126 24.071 14.4874 24.071 14.7803 23.787L22.2803 16.5143C22.5732 16.2302 22.5732 15.7698 22.2803 15.4857L14.7803 8.21301C14.4874 7.929 14.0126 7.929 13.7197 8.21301C13.4268 8.49703 13.4268 8.95752 13.7197 9.24153L20.6893 16Z"
  });
};

var _default = ChevronRightIcon;
exports.default = _default;